// This code checks how many classes are on the site named 'cat-num', this is so the backend can collect the correct classes data for EU Trademarks
  
export function logCatNumDivs() {
  const catNumDivs = document.getElementsByClassName("cat-num");
  // console.log("Number of divs with 'cat-num' class:", catNumDivs.length);

  const categoryIds = [];
  for (let i = 0; i < catNumDivs.length; i++) {
    const div = catNumDivs[i];
    const anchor = div.querySelector(".trademark-finder__selected-trademark-close");
    const categoryId = anchor.getAttribute("id");
    console.log(`Category ID of div ${i + 1}:`, categoryId);
    categoryIds.push(categoryId);
  }
  // console.log(categoryIds);
  return categoryIds;
}

export const categoryIds = [];
